module.exports = __webpack_public_path__ + "img/index.3464f378.png";